<template>
  <div>
    <van-nav-bar title="指标详情" fixed="fixed">
      <template #left>
        <div @click="$back(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
    </van-nav-bar>

    <div class="mainBody">

      <div class="newsBoxIn">

        <div class="newsBell" @click="new Date(dateTime($route.query.date,$route.query.datetime)).getTime()>=timeNow?$bell(this):null">
          <svg-icon
              :icon-class="new Date(dateTime($route.query.date,$route.query.datetime)).getTime()>=timeNow?'bell':'bellBan'"
              style="width: 12px;height: 14px"></svg-icon>
        </div>
        <div class="newsTime">{{ this.$route.query.datetime }}</div>
        <div class="newsCountryImg"><img :src="this.$route.query.countryImg"
                                         :onerror="this.$route.query.country==='中国台湾'||this.$route.query.country==='中国澳门'||this.$route.query.country==='中国香港'?flagChina:flagFill">
        </div>
        <div class="newsCountry">{{ this.$route.query.country }}</div>
        <div class="newsStarImg"><img :src="this.$route.query.starImg"></div>
        <div class="newsTitle" :style="'color:'+(this.$route.query.star>2?'#ff444e':'black')">{{
            this.$route.query.title
          }}
        </div>


        <div class="previous">前值 {{ this.$route.query.previous }}</div>
        <div class="consensus">预期 {{ this.$route.query.consensus }}</div>
        <div class="actual">公布 {{ this.$route.query.actual }}</div>


      </div>


      <div id="charts" class="chart"/>
      <transition name="fade" appear>
      <div v-if="contentRes.infos">
        <div class="contentBox">
          <div class="title">
            <div class="icon">
              <svg-icon icon-class="interpretation" style="width: 25px;height: 25px"></svg-icon>
            </div>
            <div class="titleText">数据释义</div>
          </div>
          <div class="text">{{ contentRes.infos[0].paraphrase }}</div>
        </div>
        <div class="contentBox">
          <div class="title">
            <div class="icon">
              <svg-icon icon-class="influence" style="width: 25px;height: 25px"></svg-icon>
            </div>
            <div class="titleText">数据影响</div>
          </div>
          <div class="text">{{ contentRes.infos[0].impact }}</div>
        </div>
        <div class="contentBox">
          <div class="title">
            <div class="icon">
              <svg-icon icon-class="mechanism" style="width: 25px;height: 25px"></svg-icon>
            </div>
            <div class="titleText">发布机构</div>
          </div>
          <div class="text">{{ contentRes.infos[0].institutions }}</div>
        </div>
        <div class="contentBox">
          <div class="title">
            <div class="icon">
              <svg-icon icon-class="frequency" style="width: 25px;height: 25px"></svg-icon>
            </div>
            <div class="titleText">发布频率</div>
          </div>
          <div class="text">{{ contentRes.infos[0].frequency }}</div>
        </div>
      </div>
      </transition>
    </div>


  </div>
</template>

<script>
export default {
  name: "calendarDataDetail",
  data() {
    return {
      dataRes: {},
      contentRes: {},
      flagFill: 'src="' + require('../../assets/flagFill.png') + '"',
      flagChina: 'src="http://cdn.jin10.com/images/flag/mini/中国.png"',
    }
  },
  computed: {
    screenWidth() {
      return this.$store.state.screenWidth;
    },
    timeNow() {
      return new Date().getTime()
    }
  },
  methods: {
    getData() {
      this.$get('/api/calendarChart', {id: this.$route.query.id || ''}).then(res => {
        this.dataRes = res
        if (this.dataRes.infos) {
          this.chartsInit(this.dataRes.infos)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getContent() {
      this.$get('/api/calendarCate', {id: this.$route.query.id || ''}).then(res => {
        this.contentRes = res
      }).catch(err => {
        console.log(err)
      })
    },
    chartsInit(list) {
      this.charts = this.$echarts.init(document.getElementById('charts'))
      let consensus = []
      let actual = []
      let date = []
      let dateMD = []
      for (let i = 0; i < list.length; i++) {
        let value1 = list[i].consensus
        let value2 = list[i].actual
        consensus.push({name: i, value: [i, value1]})
        actual.push({name: i, value: [i, value2]})


        let dateTime = list[i].datetime
        dateTime = dateTime.substring(0, 19);
        dateTime = dateTime.replace(/-/g, '/');
        dateMD.push(this.$format(new Date(dateTime), 'MM/dd'))
        date.push(new Date(dateTime))
      }

      let option = {
        color: ['#1875f8', '#fca342'],
        legend: {
          selectedMode: false,
          right: '16px',
        },
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let result =
                "<div style='font-size: 12px;font-weight: bolder;background-color:#1875f8;color:white;left: 0;'>" + params[0].data.value[1] + "</div>" +
                "<div style='font-size: 12px;font-weight: bolder;background-color:#fda340;color:white;left: 0;'>" + params[1].data.value[1] + "</div>" +
                "<div style='color: #999999;font-size: 11px;bottom: 0'>" + this.$format(date[params[0].data.value[0]], 'yyyy-MM-dd') + "</div>"
            return result

          }
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: '#dedede'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#919bad'
            }
          },
          axisTick: {
            show: false
          },
          type: 'category',
          data: dateMD
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#dedede'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#919bad'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee'
            }
          }
        },
        series: [
          {
            name: '实际',
            data: actual,
            type: 'line',
            symbol: 'none',
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2, // 折线宽度
                  color: '#1875f8'// 折线颜色
                }
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(200,222,254,0.8)'
                }, {
                  offset: .4,
                  color: 'rgba(200,222,254,0.3)'
                }, {
                  offset: 1,
                  color: 'rgba(200,222,254,0.00)'
                },])
              }
            },
          },
          {
            name: '预测',
            data: consensus,
            type: 'line',
            symbol: 'none',
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 2, // 折线宽度
                  color: '#fca342'// 折线颜色
                }
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(225,217,175,0.8)'
                }, {
                  offset: .4,
                  color: 'rgba(225,217,175,0.3)'
                }, {
                  offset: 1,
                  color: 'rgba(225,217,175,0.00)'
                },])
              }
            },
          },],
        title: {
          text: date[0] === date[date.length - 1] ? this.$format(date[0], 'yyyy-MM-dd') : this.$format(date[0], 'yyyy-MM-dd') + ' > ' + this.$format(date[date.length - 1], 'yyyy-MM-dd'),
          textStyle: {
            fontSize: 12,
            fontWeight: 'none',
            color: '#666666'
          }
        },
        grid: {
          right: '16px',
          bottom: '20px',

        },
      }
      this.charts.setOption(option)
      this.$store.state.watchCal = true
    },
    dateTime(date, time) {
      let dateTime = date + ' ' + time
      dateTime = dateTime.substring(0, 19);
      dateTime = dateTime.replace(/-/g, '/');
      return dateTime
    },

  },
  mounted() {
    this.getData()
    this.getContent()
  },
  watch: {
    screenWidth() {
      if (this.$store.state.watchCal) {
        this.charts.resize()
      }
    },
  }
}
</script>

<style scoped>
.mainBody {
  padding-top: 46px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
}

.chart {
  width: 100%;
  height: 60vw;
}

.newsBoxIn {
  position: relative;

}


.newsBell {
  position: absolute;
  top: 5px;
}

.newsTime {
  position: absolute;
  color: #585e6a;
  font-size: 11px;
  top: 10px;
  left: 22px;
}

.newsCountryImg {
  position: absolute;
  top: 0;
  left: 58px;
}

.newsCountry {
  position: absolute;
  top: 7px;
  left: 90px;
  color: #585e6a;
  font-size: 13px;
}

.newsStarImg {
  position: absolute;
  top: 8px;
  right: 0;
}

.newsTitle {
  padding-top: 35px;
  text-align: left;
  font-size: 15px;
  font-weight: bolder;
  padding-bottom: 45px;
}

.previous {
  color: #585e6a;
  font-size: 12px;
  position: absolute;
  left: 0;
  bottom: 10px;
}

.consensus {
  color: #585e6a;
  font-size: 12px;
  position: absolute;
  left: 45%;
  bottom: 10px;

}

.actual {
  color: #585e6a;
  font-size: 12px;
  position: absolute;
  left: 80%;
  bottom: 10px;
}

.contentBox {
  text-align: left;
  padding-top: 10px;
  padding-bottom: 10px;
}

.title {
  display: flex;
  align-items: center;
  height: 30px;
}

.icon {
  left: 0;
}

.titleText {
  margin-left: 10px;
  left: 35px;
  font-size: 13px;
  font-weight: bolder;
  color: #323440;
}

.text {
  margin: 10px 0;
  font-size: 13px;
  color: #323440;

}


.fade-enter-active {
  transition: all .3s ease;
}


.fade-enter {
  transform: translateY(-10%);
  opacity: 0;

}


</style>
